<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isloading"></loader>

        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de {{$route.meta.nota == 0 ? 'facturas':'notas'}}</h2></v-toolbar-title></pre>
        </v-toolbar>
        <div style="display: flex; gap: 10px; margin-top: 10px;">
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        :to="{ path: $route.meta.form }"
                        :loading="isloading"
                        :disabled="isloading"
                        color="orange darken-1"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-account-plus-outline</v-icon
                        >
                    </v-btn>
                </template>
                <span>Nueva factura</span>
            </v-tooltip>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        @click="imprimirLista"
                        :loading="isloading"
                        :disabled="isloading"
                        color="blue darken-1"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-printer</v-icon
                        >
                    </v-btn>
                </template>
                <span>Imprimir lista</span>
            </v-tooltip>
        </div>
        <v-row>
            <v-col cols="12" md="4">
                <FilterComponent
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponent>
                <v-checkbox
                    v-model="pendientes"
                    label="Pendientes"
                ></v-checkbox>
            </v-col>
        </v-row>
        <div style="display: flex; justify-content: end">
            <v-card
                elevation="2"
                shaped
                color="#851e31"
                width="170"
                height="70"
                class="my-5 mx-2"
            >
                <v-card-text class="text-center white--text">
                    <p class="font-weight-bold" style="margin-bottom: -4px">
                        Total facturado
                    </p>
                    {{ formatPrice(total_facturado) }}
                </v-card-text>
            </v-card>

            <v-card
                elevation="2"
                shaped
                color="#851e31"
                width="170"
                height="70"
                class="my-5 mx-2"
            >
                <v-card-text class="text-center white--text">
                    <p class="font-weight-bold" style="margin-bottom: -4px">
                        Total abonado
                    </p>
                    {{ formatPrice(total_abono) }}
                </v-card-text>
            </v-card>

            <v-card
                elevation="2"
                shaped
                color="#851e31"
                width="170"
                height="70"
                class="my-5 mx-2"
            >
                <v-card-text class="text-center white--text">
                    <p class="font-weight-bold" style="margin-bottom: -4px">
                        Pendiente
                    </p>
                    {{ formatPrice(total_pendiente) }}
                </v-card-text>
            </v-card>
        </div>
        <v-data-table
            dense
            :headers="headers"
            :items="Facturas"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :server-items-length="total_facturas"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
            @click:row="
                (item) => {
                    $router.push(`/${$route.meta.form}?id=${item.id}`);
                }
            "
            :item-class="
                () => {
                    return 'pointer';
                }
            "
        >
            <template v-slot:item.fecha="{ item }">
                {{ item.fecha | format_date }}
            </template>
            <template v-slot:item.fecha_vencimiento="{ item }">
                {{ item.fecha_vencimiento | format_date }}
            </template>
            <template v-slot:item.fechas_abono="{ item }">
                <span v-if="item.fechas_abono && item.fechas_abono.length">
                    <template
                        v-for="(f, idx) in item.fechas_abono"
                    >
                        <span :key="idx"
                            >{{ f | format_date
                            }}{{
                                idx < item.fechas_abono.length - 1 ? ', ' : ''
                            }}</span
                        >
                    </template>
                </span>
                <span v-else>—</span>
            </template>
            <template v-slot:item.obra="{ item }">
                {{ item.obra || '—' }}
            </template>
            <template v-slot:item.total_con_iva="{ item }">
                {{ formatPrice(item.total_con_iva) }}
            </template>
            <template v-slot:item.total_abono="{ item }">
                {{ formatPrice(item.total_abono) }}
            </template>
            <template v-slot:item.pendiente="{ item }">
                {{ displayPendiente(item) }}
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`api/pdf-factura/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    @click.stop="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
                <v-icon
                    @click.stop="
                        puedeAbonar(item) &&
                            openSaveDialog(item.id, item.pendiente)
                    "
                    small
                    class="mr-2"
                    :color="puedeAbonar(item) ? 'black' : 'grey lighten-1'"
                    :style="{
                        fontSize: '25px',
                        opacity: puedeAbonar(item) ? 1 : 0.5,
                        cursor: puedeAbonar(item) ? 'pointer' : 'default',
                    }"
                    :title="puedeAbonar(item) ? 'ABONAR' : 'Factura saldada'"
                    >mdi-cash</v-icon
                >
            </template>
        </v-data-table>

        <!-- Eliminar factura -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Abonar factura -->
        <v-dialog v-model="save_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col col="12" md="6">
                            <date-select v-model="abono.fecha" label="Fecha">
                            </date-select>
                        </v-col>
                        <v-col col="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            save_dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import FilterComponent from "../../../components/general/FilterComponent.vue";
import debounce from "lodash/debounce";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        FilterComponent,
    },
    data() {
        const yearActual = new Date().getFullYear();
        const anos = [];
        for (let y = yearActual; y >= yearActual - 10; y--) anos.push(y);
        const opcionesAno = [{ text: 'Todos', value: 'todos' }, ...anos.map((y) => ({ text: String(y), value: y }))];
        return {
            total_facturado: 0,
            total_abono: 0,
            total_pendiente: 0,
            save_dialog: false,
            abono: {},
            total_facturas: 0,
            page: 1,
            amount: 15,
            sortBy: [],
            sortDesc: [],
            pendientes: false,
            search: "",
            headers: [
                {
                    text: "Nº",
                    value: "nro",
                    sortable: true,
                },
                {
                    text: "Serie",
                    value: "serie",
                    sortable: true,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: true,
                },
                {
                    text: "Vto",
                    value: "fecha_vencimiento",
                    sortable: true,
                },
                {
                    text: "Fechas abono",
                    value: "fechas_abono",
                    sortable: false,
                },
                {
                    text: "Nombre fiscal",
                    value: "razon_social",
                    sortable: true,
                },

                {
                    text: "CIF/NIF",
                    value: "cif",
                    sortable: true,
                },
                {
                    text: "Obra",
                    value: "obra",
                    sortable: false,
                },
                {
                    text: "Importe",
                    value: "total_con_iva",
                    sortable: true,
                },
                {
                    text: "Abonado",
                    value: "total_abono",
                    sortable: false,
                },
                {
                    text: "Pendiente",
                    value: "pendiente",
                    sortable: false,
                },
                {
                    text: "PDF",
                    value: "pdf",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            Facturas: [],
            selectedItem: 0,
            dialog: false,

            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Serie",
                    type: "select",
                    active: false,
                    model: "serie",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Año",
                    type: "select",
                    active: false,
                    model: "ano",
                    item_text: "text",
                    item_value: "value",
                    items: opcionesAno,
                    default_value: yearActual,
                },
                {
                    title: "Clientes",
                    type: "cliente",
                    active: false,
                    model: "clientes",
                    multiple: true,
                },
                {
                    title: "Obras",
                    type: "ordenes",
                    active: false,
                    model: "obras",
                    multiple: true,
                },
                {
                    title: "Fecha vto",
                    type: "date",
                    active: false,
                    model: "fecha_vto",
                },
            ],
        };
    },
    created() {
        this.getFacturas();
        this.getSeries();
    },
    methods: {
        /** Si el importe es negativo (rectificativa/devolución), en columna se muestra 0 €. */
        displayPendiente(item) {
            const total = parseFloat(item.total_con_iva) || 0;
            const p = parseFloat(item.pendiente) || 0;
            if (total < 0) {
                return this.formatPrice(0);
            }
            return this.formatPrice(p > 0 ? p : 0);
        },
        puedeAbonar(item) {
            const p = parseFloat(item.pendiente) || 0;
            return Math.abs(p) >= 0.01;
        },
        openSaveDialog(id_factura, importe_pendiente) {
            const importe =
                importe_pendiente < 0
                    ? Math.abs(importe_pendiente)
                    : importe_pendiente;
            this.save_dialog = true;
            this.abono = {
                id_factura: id_factura,
                importe: importe,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
            };
        },
        SaveAbono() {
            axios.post(`api/save-abono`, this.abono).then(
                (res) => {
                    this.$toast.sucs("Abono guardado con éxito");
                    this.save_dialog = false;
                    this.getFacturas();
                },
                (err) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
        ChangeSize(event) {
            this.amount = event;
            this.getFacturas();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getFacturas();
        },
        buildFacturasParams(extra = {}) {
            const ano =
                this.filtros_prueba.ano?.value ?? new Date().getFullYear();
            const params = {
                page: this.page,
                amount: this.amount,
                nota: this.$route.meta.nota,
                busqueda: this.filtros_prueba.search,
                pendientes: this.pendientes ? "true" : "false",
                sort_by: this.sortBy[0],
                sort_desc: this.sortDesc[0],
                ano: ano === "todos" ? "todos" : ano,
                ...extra,
            };
            if (
                this.filtros_prueba.serie &&
                this.filtros_prueba.serie.value
            ) {
                params.serie = this.filtros_prueba.serie.value;
            }
            if (this.filtros_prueba.fecha_vto?.start) {
                params.fecha_vto_desde = this.filtros_prueba.fecha_vto.start;
            }
            if (this.filtros_prueba.fecha_vto?.end) {
                params.fecha_vto_hasta = this.filtros_prueba.fecha_vto.end;
            }
            const clientes = this.filtros_prueba.clientes?.value;
            if (Array.isArray(clientes) && clientes.length) {
                params.id_cliente = clientes;
            }
            const obras = this.filtros_prueba.obras?.value;
            if (Array.isArray(obras) && obras.length) {
                params.id_orden = obras;
            }
            return params;
        },
        getFacturas() {
            axios
                .get(`api/get-facturas`, {
                    params: this.buildFacturasParams(),
                })
                .then(
                    (res) => {
                        this.Facturas = res.data.data;
                        this.total_facturas = res.data.total;
                        this.total_facturado = res.data.importe;
                        this.total_abono = res.data.importe_abonado;
                        this.total_pendiente = res.data.importe_pendiente ?? 0;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las facturas");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Facturas.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .get(
                    `api/delete-factura/${this.Facturas[this.selectedItem].id}`
                )
                .then(
                    (res) => {
                        this.$toast.sucs("Factura eliminada con éxito");
                        this.dialog = false;
                        this.getFacturas();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando la factura");
                    }
                );
        },
        getSeries() {
            axios.get(`api/get-series`).then(
                (res) => {
                    this.filter_headers[0].items = res.data.success;
                },
                (res) => {}
            );
        },
        formatPrice,
        async imprimirLista() {
            this.$store.dispatch("isLoading", true);
            
            try {
                const titulo = this.$route.meta.nota == 0 ? 'Lista de Facturas' : 'Lista de Notas';
                const fecha = new Date().toLocaleDateString('es-ES');
                
                const params = this.buildFacturasParams({ amount: -1 });
                
                const response = await axios.get(`api/get-facturas`, { params });
                const todasLasFacturas = response.data.data;
                const totalFacturado = response.data.importe;
                const totalAbonado = response.data.importe_abonado;
                const totalPendiente = response.data.importe_pendiente ?? 0;
                
                let html = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <title>${titulo}</title>
                    <style>
                        @media print {
                            @page {
                                margin: 1cm;
                                size: A4 landscape;
                            }
                            body {
                                margin: 0;
                                padding: 0;
                            }
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 10px;
                            padding: 20px;
                        }
                        h1 {
                            text-align: center;
                            margin-bottom: 10px;
                            font-size: 18px;
                        }
                        .info-header {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 20px;
                            font-size: 11px;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 10px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 6px;
                            text-align: left;
                        }
                        th {
                            background-color: #1d2735;
                            color: white;
                            font-weight: bold;
                            text-align: center;
                        }
                        tr:nth-child(even) {
                            background-color: #f2f2f2;
                        }
                        .text-right {
                            text-align: right;
                        }
                        .totales {
                            margin-top: 20px;
                            display: flex;
                            justify-content: space-around;
                            flex-wrap: wrap;
                            gap: 10px;
                            font-weight: bold;
                            font-size: 12px;
                        }
                        .total-item {
                            padding: 10px;
                            background-color: #851e31;
                            color: white;
                            border-radius: 5px;
                            min-width: 150px;
                            text-align: center;
                        }
                    </style>
                </head>
                <body>
                    <h1>${titulo}</h1>
                    <div class="info-header">
                        <div>Fecha de impresión: ${fecha}</div>
                        <div>Total de registros: ${todasLasFacturas.length}</div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>Serie</th>
                                <th>Fecha</th>
                                <th>Vto</th>
                                <th>Fechas abono</th>
                                <th>Nombre fiscal</th>
                                <th>Obra</th>
                                <th class="text-right">Base imponible</th>
                                <th>IVA</th>
                                <th class="text-right">Importe</th>
                                <th class="text-right">Abonado</th>
                                <th class="text-right">Pendiente</th>
                            </tr>
                        </thead>
                        <tbody>
            `;
            
            const formatearFecha = (fecha) => {
                if (!fecha) return '';
                if (this.$options.filters && this.$options.filters.format_date) {
                    return this.$options.filters.format_date(fecha);
                }
                const str = fecha.split('-');
                return `${str[2]}-${str[1]}-${str[0]}`;
            };

            const cuotaIvaFactura = (factura) => {
                const iva21 = parseFloat(factura.iva_21) || 0;
                const iva10 = parseFloat(factura.iva_10) || 0;
                const iva0 = parseFloat(factura.iva_0) || 0;
                const desglose = iva21 + iva10 + iva0;
                if (desglose !== 0) {
                    return Math.round(desglose * 100) / 100;
                }
                const pct = parseFloat(factura.iva) || 0;
                if (pct > 0 && factura.nota != 1) {
                    return (
                        Math.round(
                            (parseFloat(factura.total) || 0) * (pct / 100) * 100
                        ) / 100
                    );
                }
                return 0;
            };

            const formatearIva = (factura) => {
                const partes = [];
                const iva21 = parseFloat(factura.iva_21) || 0;
                const iva10 = parseFloat(factura.iva_10) || 0;
                const iva0 = parseFloat(factura.iva_0) || 0;

                if (iva21 !== 0) {
                    partes.push(
                        `${this.formatPrice(iva21)} (iva 21%)`
                    );
                }
                if (iva10 !== 0) {
                    partes.push(
                        `${this.formatPrice(iva10)} (iva 10%)`
                    );
                }
                if (iva0 !== 0) {
                    partes.push(
                        `${this.formatPrice(iva0)} (iva 0%)`
                    );
                }

                if (partes.length) {
                    return partes.join('<br>');
                }

                // Facturas antiguas con un solo % en campo iva
                const pct = parseFloat(factura.iva) || 0;
                if (pct > 0 && factura.nota != 1) {
                    const cuota = cuotaIvaFactura(factura);
                    return `${this.formatPrice(cuota)} (iva ${pct}%)`;
                }

                return '—';
            };

            let totalBaseImponible = 0;
            let totalIva = 0;
            
            todasLasFacturas.forEach(factura => {
                totalBaseImponible += parseFloat(factura.total) || 0;
                totalIva += cuotaIvaFactura(factura);
                const fechasAbono = (factura.fechas_abono || [])
                    .map((f) => formatearFecha(f))
                    .filter(Boolean)
                    .join(', ');
                html += `
                    <tr>
                        <td>${factura.nro || ''}</td>
                        <td>${factura.serie || ''}</td>
                        <td>${formatearFecha(factura.fecha)}</td>
                        <td>${formatearFecha(factura.fecha_vencimiento)}</td>
                        <td>${fechasAbono || '—'}</td>
                        <td>${factura.razon_social || ''}</td>
                        <td>${factura.obra || '—'}</td>
                        <td class="text-right">${this.formatPrice(factura.total)}</td>
                        <td>${formatearIva(factura)}</td>
                        <td class="text-right">${this.formatPrice(factura.total_con_iva)}</td>
                        <td class="text-right">${this.formatPrice(factura.total_abono)}</td>
                        <td class="text-right">${this.displayPendiente(factura)}</td>
                    </tr>
                `;
            });
            
            html += `
                        </tbody>
                    </table>
                    <div class="totales">
                        <div class="total-item">
                            <div>Total base imponible</div>
                            <div>${this.formatPrice(totalBaseImponible)}</div>
                        </div>
                        <div class="total-item">
                            <div>Total IVA</div>
                            <div>${this.formatPrice(totalIva)}</div>
                        </div>
                        <div class="total-item">
                            <div>Total facturado</div>
                            <div>${this.formatPrice(totalFacturado)}</div>
                        </div>
                        <div class="total-item">
                            <div>Total abonado</div>
                            <div>${this.formatPrice(totalAbonado)}</div>
                        </div>
                        <div class="total-item">
                            <div>Pendiente</div>
                            <div>${this.formatPrice(totalPendiente)}</div>
                        </div>
                    </div>
                </body>
                </html>
            `;
                
                const ventanaImpresion = window.open('', '_blank');
                ventanaImpresion.document.write(html);
                ventanaImpresion.document.close();
                
                setTimeout(() => {
                    ventanaImpresion.print();
                }, 250);
            } catch (error) {
                this.$custom_error("Error al obtener las facturas para imprimir");
                console.error(error);
            } finally {
                this.$store.dispatch("isLoading", false);
            }
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
    watch: {
        "$route.meta": function (val) {
            this.getFacturas();
        },
        pendientes: function (val) {
            this.getFacturas();
        },
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                this.getFacturas();
            },
        },
        sortBy: {
            handler: debounce(function () {
                this.getFacturas();
            }, 100),
            deep: true,
        },
        sortDesc: {
            handler: debounce(function () {
                this.getFacturas();
            }, 100),
            deep: true,
        },
    },
};
</script>
